import React from 'react';
import Box from '@mui/material/Box';
import { useTranslation } from '../hook/Translation';
import Accordions from '../components/Accordions/Accordions';
import { Grid, Typography } from '@mui/material';
import ContentCard from '../components/Cards/ContentCard';
import BigCard from '../components/Cards/BigCard';
import SmallCards from '../components/Cards/SmallCards';
import TextBtnSection from '../components/Section/TextBtnSection';
import HalfSizeBanner from '../components/Banners/HalfSizeBanner';

export default function ExionClearRf() {

    const { t } = useTranslation();

    const data2 = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: t('exion_clear_rf.time'),
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: t('exion_clear_rf.discomfort'),
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: t('exion_clear_rf.downtime'),
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: t('exion_clear_rf.sessions'),
        }
    ];

    const accodirons = [
       
        {
            title: t('benefits'),
            content: t('exion_clear_rf.benefits')
        },
        {
            title: t('zone'),
            content: t('exion_clear_rf.zone')
        },
        {
            title: t('pairs'),
            content: t('exion_clear_rf.pairs')
        },
        {
            title: t('when_expected_results'),
            content: t('exion_clear_rf.expected_results')
        },
    ]

    const TextBtnSectionData = {
        type: t('skinTherapies'),
        title: t('exion_clear_rf.mainTitle'),
        description: t('exion_clear_rf.mainDesc'),
        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION™ Clear RF")}`,
        price: `${t('price_session')} €350`,

        doctorIncluded: true
    };

    return (
        <Box>
            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08ee034e332.15570718.jpg`} width={1} height={1} sx={{ objectFit: 'cover' }} />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '80px', xs: '50px' }}>
                <TextBtnSection data={TextBtnSectionData} titleSize={{ md: 5.9, xs: 12 }} descriptionSize={{ md: 9, xs: 12 }} />
            </Box>
            <Box marginTop={{ md: '107px', xs: '50px' }}>
                <Box component={'img'} src='/images/fractional/Path 134.svg' width={1} sx={{ objectFit: 'cover' }} />
            </Box>

            <Box>
                <Box marginTop={{ md: '104px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data2} />
                </Box>
            </Box>
            <Box sx={{ width: { md: '65%', xs: '90%' }, marginX: 'auto', marginTop: { md: '80px', xs: '50px' } }}>
                <Box sx={{ height: { md: 500, xs: 'auto' } }}>
                    <BigCard
                        data={{
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION™ Clear RF")}`,
                            type: t('exion_clear_rf.tech'),
                            // learn: '/',
                            title: t('exion_clear_rf.techTitle'),
                            size: { md: 6.5, xs: 12 },
                            btnContainer: { md: 10, xs: 12 },
                            imageSize: { md: 5.5, xs: 12 },
                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/01/ALMA.png`,
                            flexDirection: { md: 'row-reverse', xs: 'column-reverse' },
                            description: t('exion_clear_rf.techDesc')
                        }}
                        extraStyle={{
                            background: 'linear-gradient(90deg,rgba(30, 53, 61, 1) 0%, rgba(30, 53, 61, 1) 35%, rgba(30, 53, 61, 1) 50%, rgba(30, 53, 61, 1) 100%)'
                        }}
                        bgColor={'unset'}
                    />
                </Box>
            </Box>
            <Grid container gap={{ md: '80px', xs: '50px' }} className="generalContainer" sx={{ marginX: 'auto', marginTop: { md: '80px', xs: '50px' } }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'bold'}>{t('additional_information')}</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={accodirons} />
                </Grid>
            </Grid>

            <Box bgcolor={'#f0f0ef'} marginTop={{ md: '131px', xs: '50px' }}>
                <Box className="generalContainer" display={'flex'} flexDirection={'column'} gap={{ md: '89px', xs: '50px' }} marginX={'auto'} paddingTop={{ md: '120px', xs: '50px' }} paddingBottom={{ md: '188px', xs: '50px' }}>
                    <ContentCard
                        data={{

                            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2026/04/img_69f08d65c7b999.25863689.jpg`,
                            type: 'Kombinimet',
                            title: 'EXION™ Fractional Microneedling RF',
                            description: 'EXION™ Fractional Microneedling RF është një teknologji e avancuar për rigjenerim të thellë të lëkurës në fytyrë dhe trup. Duke kombinuar microneedling monopolar me radiofrekuencë të kontrolluar nga inteligjenca artificiale, ky trajtim aktivizon proceset natyrale të ripërtëritjes së lëkurës, stimulon prodhimin e kolagjenit dhe elastinës dhe përmirëson strukturën e saj në mënyrë të kontrolluar dhe të sigurt.',
                            book: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e EXION™ Fractional Microneedling RF")}`,
                            learn: '/skin/rf-collagen-induction'
                        }}
                        heigth={{ md: '440px', xs: 'auto' }}
                    />
                </Box>
            </Box>
        </Box>
    )
}